import { useDispatch, useSelector } from "react-redux";
import useAlerts from "../useAlerts";
import useModals from "../useModals";
import { AppDispatch, RootState } from "../../store/store";
import useLoading from "../useLoading";
import useApiErrorHandler from "../useApiErrorHandler";
import BrandService from "../../services/product/BrandService";
import { addBrand, deactivateStateBrand, loadingBrands, loadingBrandsDropdown, updateBrand } from "../../store/slices/product/brandSlice";




export const useBrands = () => {

    const { show: showAlert } = useAlerts();
    const { openModal } = useModals();

    const dispatch: AppDispatch = useDispatch();

    const { showLoadingIndicator, hideLoadingIndicator } =
        useLoading();

    const { handle } = useApiErrorHandler();

    const {
        brands,
        brandsDropdown,
        brandSelected,
    } = useSelector(
        (state: RootState) => state.brand
    );

    const handlerSearchByType = async ({
        searchType,
        name,
    }) => {

        try {

            showLoadingIndicator();

            let result;

            switch (searchType) {

                case "all":

                    result = await BrandService.getAll();

                    dispatch(
                        loadingBrands(result)
                    );

                    break;

                case "name":

                    result =
                        await BrandService.findByName(
                            name
                        );

                    
                    dispatch(
                        loadingBrands(
                            result?.data ?? []
                        )
                    );

                    break;

                default:

                    throw new Error(
                        `Tipo de búsqueda no válido: ${searchType}`
                    );
            }

        } catch (error: any) {

            handle(error);

        } finally {

            hideLoadingIndicator();
        }
    };

    const fetchBrands = async () => {

        try {

            showLoadingIndicator();

            const response =
                await BrandService.getAll();

            dispatch(
                loadingBrands(response)
            );

        } catch (error) {

            handle(error);

        } finally {

            hideLoadingIndicator();
        }
    };

    const fetchBrandsDropdown = async () => {

        try {

            const response =
                await BrandService.getDropdown();

            dispatch(
                loadingBrandsDropdown(
                    response
                )
            );

        } catch (error) {

            handle(error);
        }
    };

    const handlerAddBrand = async (
        data: {
            id: number;
            name: string;
        }
    ) => {

        try {

            if (data.id === 0) {

                const { id, ...brandData } =
                    data;

                const response =
                    await BrandService.save(
                        brandData
                    );

                const {
                    title,
                    message,
                    type,
                    data: newBrand,
                } = response;

                if (newBrand) {

                    dispatch(
                        addBrand(newBrand)
                    );
                }

                openModal(
                    type,
                    {
                        title,
                        message,
                    }
                );

            } else {

                const response =
                    await BrandService.update(
                        data.id,
                        data.name
                    );

                const {
                    title,
                    message,
                    type,
                    data: updatedBrand,
                } = response;

                if (updatedBrand) {

                    dispatch(
                        updateBrand(
                            updatedBrand
                        )
                    );
                }

                openModal(
                    type,
                    {
                        title,
                        message,
                    }
                );
            }

        } catch (error: any) {

            handle(error);
        }
    };

    const toggleBrandStatus = async (
        id: number
    ) => {

        try {

            const response =
                await BrandService.deactivate(
                    id
                );

            const title =
                response?.title ??
                "Operación completada";

            const message =
                response?.message ??
                "El estado de la marca ha sido actualizado.";

            const type =
                response?.type ??
                "success";

            showAlert(
                type,
                title,
                message
            );

            dispatch(
                deactivateStateBrand(
                    response?.data ?? {}
                )
            );

        } catch (error: any) {

            handle(error);
        }
    };

    return {
        brands,
        brandsDropdown,
        brandSelected,

        handlerSearchByType,

        fetchBrands,
        fetchBrandsDropdown,

        handlerAddBrand,
        toggleBrandStatus,
    };
};